import { bodyLockToggle } from "./helpers/body-lock-toggle";

window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let gallerySplidePanel = document.querySelectorAll('.gallery-panel');
    let instagramSplidePanel = document.querySelectorAll('.instagram-panel')
    let mediaSplidePanel = document.querySelectorAll('.slider-panel');

    if (availableCarousels.length) {
        // START GALLERY PANEL SLIDER
        for ( let panel of gallerySplidePanel ) {
            let parentPanel = panel.closest('.gallery-panel');
            let galleryThumbnails = parentPanel.querySelectorAll('.gallery-panel-image');
            let lightbox = parentPanel.querySelector('.gallery-panel-lightbox');
            let lightboxBackdrop = (lightbox ? lightbox.querySelector('.lightbox-backdrop') : null);
            let lightboxClose = (lightbox ? lightbox.querySelector('.lightbox-close') : null);
            let totalSlides = parentPanel.querySelector('.gallery-splide').dataset.totalSlides;
            let progressBar = (lightbox ? lightbox.querySelector('.carousel-progress-bar') : null);
            let currentPostCounter = parentPanel.querySelector('.gallery-splide-current-slide');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let lbox = new Splide(panel.querySelector('.gallery-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full flex items-center justify-between',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 rounded-l-lg w-14 h-16 p-2 bg-gray-brand bg-opacity-20 md:bg-transparent md:p-0 md:w-10 md:h-12 fill-current text-white-brand disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            let gallerySplide = new Splide(panel.querySelector('.gallery-splide'), {
                type: 'slide',
                speed: 750,
                perPage: 4,
                gap: '2rem',
                perMove: 1,
                arrows: true,
                padding: { left: '2rem', right: '2rem' },
                classes: {
                    arrows: 'splide__arrows absolute w-max h-max flex items-center justify-between hidden 1.5xs:flex -top-12 right-6 lg:right-8 gap-4',
                    arrow: 'splide__arrow no-tap-to-zoom relative z-5 bg-transparent p-2 w-10 h-12 fill-current text-gray-brand disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev rotate-180',
                    next: 'splide__arrow--next',
                },
                breakpoints: {
                    1024: {
                        perPage: 3,
                        padding: { left: '2rem', right: '2rem' },
                        gap: '2rem'
                    },
                    640: {
                        perPage: 2,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                    480: {
                        perPage: 1,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                },
            });

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
                bodyLockToggle();
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                document.documentElement.classList.toggle('body-lock-scroll-modal');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
                bodyLockToggle();
            }


            // Closes lightbox on backdrop/close button press

            lightboxBackdrop.addEventListener('click', () => {
                closeLightBox();
            });

            lightboxClose.addEventListener('click', () => {
                closeLightBox();
            });

            // Closes lightbox on key 'esc' press or navigates slider on keys 'arrowLeft' and 'arrowRight'

            document.addEventListener("keydown", (e) => {
                if (!lightbox.classList.contains('hidden')) {
                    if (e.key === "Escape") {
                        closeLightBox();
                    }
                    else if (e.key === "ArrowRight") {
                        lbox.go('+1');
                    }
                    else if (e.key === "ArrowLeft") {
                        lbox.go('-1');
                    }
                }
            });

            // Opens lightbox and navigates carousel to the thumbnail that was pressed

            for ( let thumbnail of galleryThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        lbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            // Updates carousel progress bar width

            lbox.on('mounted move', function () {
                let end = lbox.Components.Controller.getEnd() + 1;
                progressBar.style.width = String(100 * (lbox.index + 1) / end) + '%';
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        gallerySplide.go('+1');
                    }
                    else {
                        gallerySplide.go('-1');
                    }
                });
            }

            gallerySplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (gallerySplide.index + 1).toString();
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (gallerySplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (gallerySplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }
            });

            lbox.mount();
            gallerySplide.mount()
            gallerySplide.sync(lbox);
        }
        // END GALLERY PANEL SLIDER
    }
});
